
<div class="people-management-home-container">
    <div class="people-management-header">
        <div id="header-app-container">
            <div #headerAppContainer class="header-app"></div>
        </div>
    </div>
    <div class="people-management-home-page errorModal">
        <div class="alertIcon">
            <img src="../../../../../assets/alertIcon.svg" alt="Alert">
        </div>
        <p class="adimin-error">{{errorMessage}}</p>
        <p class="admin-message">{{errorResolutionText}} </p>
    </div>
</div>